import React, { Dispatch, FC, SetStateAction } from 'react';
import { View } from 'react-native';
import { scale as initialScale } from '@components/frame';
import ActionMenu from '@components/common/actionMenu';
import { fontOP } from '@styles/fonts';
import { connect } from 'react-redux';
import { clear } from '@reducers/user';
import { unlogin } from '@reducers/utils';
import { goToMainApp } from '@components/operatorPanel/helpers/goToMainApp';
import { getBoxShadowStyle } from '@styles/shadow';
import ModalWrapper from '@components/modal/ModalWrapper';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { WithColor } from '@styles/colors';

interface OperatorPanelSettingsActionsModalProps extends WithColor {
  setShowOperatorPanelSettingsActionModal: Dispatch<SetStateAction<boolean>>;
  setLogoutInProgress: Dispatch<SetStateAction<boolean>>;
  clear: () => void;
  unlogin: () => void;
  scale?: ScaleFunction;
}

const OperatorPanelSettingsActionsModal: FC<OperatorPanelSettingsActionsModalProps> = ({
  C,
  setShowOperatorPanelSettingsActionModal,
  setLogoutInProgress,
  clear,
  unlogin,
  scale = initialScale,
}) => {
  const logOff = () => {
    setLogoutInProgress(true);
    clear();
    unlogin();
  };

  const items = [
    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Log Off',
        font: fontOP.Body,
      },
      testID: TEST_IDS.operatorPanel.settings.actionsMenuLogOff,
      onPress: () => {
        setShowOperatorPanelSettingsActionModal(false);
        logOff();
      },
    },
    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Go To Main App',
        font: fontOP.Body,
      },
      testID: TEST_IDS.operatorPanel.settings.actionsMenuGoToMainApp,
      onPress: () => {
        setShowOperatorPanelSettingsActionModal(false);
        goToMainApp();
      },
    },
  ];

  const modalShadow = getBoxShadowStyle({ type: 'Wide', scheme: 'light' });

  return (
    <ModalWrapper C={C} onBackdropPress={() => setShowOperatorPanelSettingsActionModal(false)}>
      <View
        style={[
          {
            position: 'absolute',
            top: scale(47),
            left: scale(22),
            backgroundColor: C('Background/Light/Modal'),
            borderRadius: scale(SCREEN_BORDER_RADIUS),
          },
        ]}
      >
        <ActionMenu {...{ C, items, font: fontOP, borderRadius: scale(SCREEN_BORDER_RADIUS), boxShadow: modalShadow, bg: 'Background/Light/Modal', scale }} />
      </View>
    </ModalWrapper>
  );
};

export default connect(null, { clear, unlogin })(OperatorPanelSettingsActionsModal);
